// extracted by mini-css-extract-plugin
export default {"steps":"style_steps__M2Q8z"};